import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

/**
 * Inline error strip rendered inside a form, replacing the browser alert()
 * that ACCB forms previously used.
 
 * Renders nothing when there is no message, so it is safe to leave mounted.
 * `style` is applied inline, so callers can override spacing (e.g. marginTop: 0).
 */
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    padding: "0.5em",
    border: `1px solid ${theme.palette.error.light}`,
    backgroundColor: "rgba(211, 47, 47, 0.04)",
    marginTop: theme.spacing(1),
  },
  icon: {
    color: theme.palette.error.main,
    fontSize: 18,
    marginTop: 1,
    flexShrink: 0,
  },
  text: {
    color: theme.palette.error.main,
    textAlign: "left",
    fontSize: '0.85rem',
  },
}));

const FormError = ({ message, style }) => {
  const classes = useStyles();

  if (!message) return null;

  return (
    <Box role="alert" className={classes.root} style={style}>
      <ErrorOutlineIcon className={classes.icon} />
      <Typography className={classes.text}>{message}</Typography>
    </Box>
  );
};

export default FormError;
